<template>
    <section>
        <v-row>
            <v-col cols="9">
                <span class="subtitle-1 font-weight-bold">Deltaker {{number}}</span>
            </v-col>
            <v-col cols="1">
                <v-btn x-small top block text v-if="number > 1" @click="$emit('remove-participant', number)">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-text-field v-model="$parent.$parent.contacts[number-1].firstname" label="Fornavn"  class="required tile" dense single-line outlined :rules="[v => !!v || 'Fornavn er påkrevd!']"></v-text-field>
        <v-text-field v-model="$parent.$parent.contacts[number-1].lastname" label="Etternavn" class="required tile" dense single-line outlined :rules="[v => !!v || 'Etternavn er påkrevd!']"></v-text-field>
        <Date class="required tile" :value="birhtDateValue" @input="(value) => $parent.$parent.contacts[number-1].birthdate = value" />
        <v-text-field v-model="$parent.$parent.contacts[number-1].emailaddress1" label="Epost"  class="required tile" dense single-line outlined :rules="[v => !!v || 'Epost er påkrevd!']"></v-text-field>
        <v-text-field v-model="$parent.$parent.contacts[number-1].telephone1" label="Telefon" class="required tile" outlined single-line dense :rules="[v => !!v || 'Telefon er påkrevd!']"></v-text-field>  
    </section>
</template>

<script>
import Date from './Date.vue';
export default {
    components: {
        Date
    },
    props: ['number'],
    data() {
      return {
        fromDateMenu: false,
      };
    },
    computed: {
        birhtDateValue(){
            var birthdate = this.$parent.$parent.contacts[this.number-1].birthdate 
            return birthdate == null ? '': birthdate;
        },
    }
}
</script>